export const focusAreas = {
  reviewManagement: {
    title: "Proactive Review Management",
    icon: "Star",
    symptoms: [
      "Few or no online reviews for your business",
      "No system for requesting customer reviews",
      "Not responding to reviews consistently",
      "Negative reviews without any business response"
    ],
    impacts: [
      "Potential customers choose competitors with more reviews",
      "Missing social proof that drives purchase decisions",
      "Negative reviews disproportionately influence perception",
      "Lost opportunities to showcase customer satisfaction"
    ],
    solutions: [
      "Implement systematic review request process for every customer",
      "Create easy review pathways (direct links, QR codes, follow-up emails)",
      "Set up automated review request campaigns post-purchase",
      "Respond to all reviews within 24-48 hours professionally",
      "Thank positive reviewers and showcase their feedback",
      "Address negative reviews with empathy and solutions",
      "Train staff on importance of earning reviews",
      "Incentivize (legally) customer feedback and testimonials"
    ],
    nextSteps: [
      "Claim and optimize profiles on Google, Facebook, Yelp",
      "Create review request email template and process",
      "Set up review monitoring alerts for new feedback",
      "Respond to all existing reviews (start with negative ones)"
    ],
    insight: "Reviews are the new word-of-mouth. 93% of consumers read online reviews before making a purchase decision, and 91% trust online reviews as much as personal recommendations. For Saskatchewan businesses, even a half-star increase in rating can increase revenue by 5-9%. Proactive review management isn't optional - it's essential for growth."
  },
  onlineMonitoring: {
    title: "Comprehensive Online Monitoring",
    icon: "Visibility",
    symptoms: [
      "Unaware of what people say about you online",
      "Discovering negative reviews weeks or months later",
      "Missing mentions on social media or review sites",
      "No alerts when your business is discussed online"
    ],
    impacts: [
      "Damage spreads before you can respond or address issues",
      "Lost opportunities to engage with customers discussing your brand",
      "Unable to identify and fix recurring customer complaints",
      "Competitors aware of your reputation issues before you are"
    ],
    solutions: [
      "Set up Google Alerts for your business name and variations",
      "Use reputation monitoring tools (ReviewTrackers, Podium, BirdEye)",
      "Monitor all major review platforms daily (Google, Facebook, Yelp, industry-specific)",
      "Track social media mentions and hashtags",
      "Subscribe to notification alerts from review platforms",
      "Implement reputation dashboard to track metrics over time",
      "Monitor competitor reviews to identify opportunities",
      "Set up keyword monitoring for industry conversations"
    ],
    nextSteps: [
      "Create Google Alerts for business name variations",
      "List all platforms where customers might review you",
      "Schedule daily 15-minute reputation check routine",
      "Consider investing in reputation monitoring software"
    ],
    insight: "What you don't know can hurt you. The average customer tells 9 people about a positive experience, but tells 16 people about a negative one. In Saskatchewan's tight-knit communities, word spreads fast. Monitoring your online reputation lets you respond quickly, turn detractors into advocates, and identify service improvements before small issues become big problems."
  },
  brandTrust: {
    title: "Building Brand Trust & Credibility",
    icon: "Verified",
    symptoms: [
      "Low online star ratings or mixed reviews",
      "Inconsistent customer experiences reflected in feedback",
      "No positive content to counterbalance occasional negatives",
      "Weak online presence makes business seem unreliable"
    ],
    impacts: [
      "Potential customers don't trust your business enough to buy",
      "Difficulty commanding premium pricing in your market",
      "Lower conversion rates from website and marketing efforts",
      "Struggling to compete against better-reviewed competitors"
    ],
    solutions: [
      "Deliver exceptional customer service worthy of 5-star reviews",
      "Showcase customer testimonials on website and marketing",
      "Build case studies demonstrating successful customer outcomes",
      "Maintain consistent brand messaging across all platforms",
      "Address service issues identified in reviews systematically",
      "Highlight awards, certifications, and local community involvement",
      "Use video testimonials to add authenticity",
      "Partner with local Saskatchewan organizations for credibility",
      "Share behind-the-scenes content showing your team and values"
    ],
    nextSteps: [
      "Audit current online presence for trust signals",
      "Collect and showcase 5-10 strong customer testimonials",
      "Identify and fix any service issues causing negative feedback",
      "Create content that demonstrates expertise and reliability"
    ],
    insight: "Trust is the foundation of every sale. 84% of people trust online reviews as much as personal recommendations, and businesses with 4+ star ratings get 82% more conversions than those below 3 stars. For Saskatchewan businesses, building trust online translates directly to more customers choosing you over competitors. Your reputation is your most valuable marketing asset."
  }
};
